import config from '../../config.js';

class CreateAppointmentServ {

    constructor($http, apiServ) {
        this.$http = $http;
        this.apiServ = apiServ;
        this.config = config;
    }

    yyyymmdd(dateObj, separator) {

        if (!dateObj || !dateObj.getMonth) return null;

        separator = separator || '-';

        var yyyy = dateObj.getFullYear().toString(),
            mm = (dateObj.getMonth() + 1).toString(),
            dd = dateObj.getDate().toString();
        return yyyy + separator + (mm[1] ? mm : "0" + mm[0]) + separator + (dd[1] ? dd : "0" + dd[0]);
    }

    ddmmyyyy(dateObj, separator) {
        if (!dateObj || !dateObj.getMonth) return null;

        separator = separator || '-';

        var yyyy = dateObj.getFullYear().toString(),
            mm = (dateObj.getMonth() + 1).toString(),
            dd = dateObj.getDate().toString();
        return (dd[1] ? dd : "0" + dd[0]) + separator + (mm[1] ? mm : "0" + mm[0]) + separator + yyyy;
    }

    getStartAndEndOfTheMonth(dateObj) {

        if (!angular.isObject(dateObj) || !dateObj.getMonth) return [];

        var firstDay = this.yyyymmdd(dateObj),
            lastDay = this.yyyymmdd(new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0));

        return [firstDay, lastDay];
    }

    createAppointment(pos, appointment) {
        return this.$http({
            url: this.apiServ.readUrl('appointment') + '/' + pos,
            method: 'POST',
            data: appointment,
            headers: {
                'Authorization': this.config.submitToken
            }
        });
    }
}

CreateAppointmentServ.$inject = ['$http', 'apiServ'];

export default CreateAppointmentServ;